import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'
import {
    RaketaRPKListResponseT,
    RaketaRPKPayloadT,
    RaketaRPKResponseT,
    RPKCreatePayloadT,
    RPKExportExcelParamsT,
    RPKListParamsT,
    RPKListResponseT,
    RPKPayloadT,
    RPKResponseT,
    RPKTypesResponseT,
} from '@/core/types/rpk.types'

export class RPKRepository {
    getRaketaRPKList(params: RPKListParamsT): Promise<AxiosResponse<RaketaRPKListResponseT>> {
        return http.get(`/delivery/api/payment-by-courier`, { params })
    }

    getRPKList(params: RPKListParamsT): Promise<AxiosResponse<RPKListResponseT>> {
        return http.get(`/cabinet/api/payment-by-courier`, { params })
    }

    getRaketaRPK(id: number): Promise<AxiosResponse<RaketaRPKResponseT>> {
        return http.get(`/delivery/api/payment-by-courier/${id}`)
    }

    getRPK(id: number): Promise<AxiosResponse<RPKResponseT>> {
        return http.get(`/cabinet/api/payment-by-courier/${id}`)
    }

    getTypes(): Promise<AxiosResponse<RPKTypesResponseT>> {
        return http.get(`/cabinet/api/payment-by-courier/type`)
    }

    changeStatusRPK(rpk_id: number, status_code: string): Promise<AxiosResponse<void>> {
        const params = {
            status_code,
        }

        return http.put(`/cabinet/api/payment-by-courier/status/${rpk_id}`, params)
    }

    editRaketaRPK(payload: RaketaRPKPayloadT): Promise<AxiosResponse<void>> {
        return http.put(`/delivery/api/payment-by-courier/${payload.id}`, payload)
    }

    editRPK(payload: RPKPayloadT): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/payment-by-courier/${payload.id}`, payload)
    }

    exportExcel(params: RPKExportExcelParamsT): Promise<any> {
        return http.get(`/cabinet/api/payment-by-courier/export`, { params, responseType: 'blob' })
    }

    exportExcelRaketa(id: number): Promise<any> {
        return http.get(`/delivery/api/payment-by-courier/${id}/export`, {
            params: { id },
            responseType: 'blob',
        })
    }

    createRaketaRPK(payload: RPKCreatePayloadT): Promise<AxiosResponse<void>> {
        return http.post('/delivery/api/payment-by-courier', payload)
    }

    deleteRPK(id: number): Promise<AxiosResponse<void>> {
        return http.delete(`/cabinet/api/payment-by-courier/${id}`)
    }
}
